/* 🤖 this file was generated by script */
export const wiconChevronRight = {
  name: 'chevron_right',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 18l6-6-6-6"/></svg>`,
};
